<template>
  <resource-box :name="title ? title : '每省公司分布top10'">
    <div class="bar-card" slot="content">
      <div ref="barRef" class="chart-container"></div>
    </div>
  </resource-box>
</template>

<script>
import * as echarts from 'echarts';
import ResourceBox from '@/views/ChinaMapData/components/common/resourceBox.vue';
import { getCompanyTop10 } from '@/API/chinaMapApi/chinaMapApi';
export default {
  components: {
    ResourceBox,
  },
  props: {
    title: {
      type: String,
      default: undefined,
    },
    // 满足切换到总览大屏情况下，组件能被复用
    dataType: {
      type: String,
      default: undefined,
    },
  },
  name: 'BarChart',
  data() {
    return {
      xAxisData: [],
      seriesData: [],
      fullNames: [], // 存储完整的名称用于 tooltip 显示
      chartInstance: null, // 存储 ECharts 实例
    };
  },
  watch: {
    '$store.state.chinaMap.dataType': {
      handler: function (val) {
        this.getTop10();
      },
    },
  },
  mounted() {
    this.getTop10();
  },
  methods: {
    async getTop10() {
      this.xAxisData = [];
      this.seriesData = [];
      try {
        let params;
        if (this.dataType) {
          params = {
            types: this.dataType
          };
        } else {
          params = {
            types: this.$store.state.chinaMap.dataType == 1 ? '1,3' : '2,3',
          };
        }

        const res = await getCompanyTop10(params);
        if (res.code === 200 && res.data) {
          res.data.forEach((item) => {
            this.xAxisData.push(item.provinceName);
            this.seriesData.push(item.companyCount);
          });
          this.initChart();
        } else {
          console.error('接口返回数据异常:', res);
          this.initEmptyChart(); // 数据为空时显示空状态
        }
      } catch (error) {
        console.error('请求失败:', error);
        this.initEmptyChart(); // 请求失败时显示空状态
      }
    },
    // 初始化空状态图表
    initEmptyChart() {
      // 先清空旧实例
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
      const chart = echarts.init(this.$refs.barRef);
      this.chartInstance = chart;
      const option = {
        title: {
          text: '暂无数据',
          left: 'center',
          top: '75%',
          padding: [10, 20, 10, 20],
          textStyle: {
            color: '#909399',
            fontSize: 14,
            fontWeight: 'normal',
          },
        },
        graphic: {
          type: 'image',
          id: 'empty-icon',
          left: 'center',
          top: '25%',
          style: {
            image: this.emptyImg,
            width: 150,
            height: 150,
            opacity: 1,
          },
          bounding: 'content',
        },
        xAxis: { show: false },
        yAxis: { show: false },
        grid: { left: 0, right: 0, bottom: 0, top: 0 },
        series: [],
        backgroundColor: 'transparent',
      };
      chart.setOption(option);
      window.addEventListener('resize', () => chart.resize());
    },
    initChart() {
      // 先清空旧实例
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
      // 确保数据存在且非空
      if (!this.xAxisData.length || !this.seriesData.length) {
        console.warn('X轴或Y轴数据为空，无法初始化图表');
        return;
      }

      // 初始化 ECharts 实例
      const chart = echarts.init(this.$refs.barRef);
      this.chartInstance = chart;
      // 配置图表选项
      const option = {
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
        xAxis: {
          type: 'category',
          data: this.xAxisData, // X轴数据：公司名称
          axisLine: { lineStyle: { color: 'rgba(255,255,255,0.2)' } },
          axisLabel: {
            color: '#fff',
            interval: 0, // 强制显示所有标签
            rotate: 45, // 旋转标签避免重叠
          },
        },
        yAxis: {
          type: 'value',
          name: '单位 (家)',
          nameTextStyle: {
            color: '#fff',
          },
          axisLine: { lineStyle: { color: 'rgba(255,255,255,0.2)' } },
          axisLabel: {
            color: '#fff',
            fontSize: 11,
            formatter: (value) => {
              // Y 轴数值格式化，超过 1000 显示为 k 单位
              if (value >= 1000) {
                return (value / 1000).toFixed(0) + 'k';
              }
              return value;
            },
          },
          splitLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } },
        },
        series: [
          {
            name: '公司数量',
            type: 'bar',
            data: this.seriesData, // Y轴数据：公司数量
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#4DE2A8' },
                { offset: 1, color: '#105C3E' },
              ]),
              borderRadius: [4, 4, 0, 0],
            },
            barWidth: '35%', // 柱状图宽度
          },
        ],
        backgroundColor: 'transparent',
        label: {
          show: true,
          position: 'top',
          color: '#fff',
          fontSize: 10,
          formatter: (params) => {
            return params.value !== null && params.value !== undefined
              ? params.value
              : '';
          },
        },
      };

      // 设置图表配置
      chart.setOption(option);

      // 监听窗口大小变化，自适应图表尺寸
      window.addEventListener('resize', () => chart.resize());
    },
  },
};
</script>

<style scoped>
.bar-card {
  border-radius: 8px;
  width: 100%;
  height: 100%;
  padding: 16px;
  flex: 1;
}
.chart-container {
  width: 100%;
  height: 100%;
}
</style>
